import { IdiomaModel } from './shared/models/idioma.model';
import { IdiomaService } from 'src/app/core/services/idioma.service';
import { Component, OnInit, ElementRef } from '@angular/core';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { CookieService } from './core/services/cookie.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit {
  constructor(
    private translate: TranslateService,
    private el: ElementRef,
    private idiomaService: IdiomaService,
    private cookieService: CookieService,
    private localize: LocalizeRouterService
  ) {
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.localize.changeLanguage(event.lang);
      this.idiomaService.setIdioma(IdiomaModel.carregarIdioma(event.lang));
      this.setElementLang(event.lang);
    });
  }

  ngOnInit() {
    const language = this.localize.parser.urlPrefix;
    this.translate.setDefaultLang(language);
    this.idiomaService.setIdioma(IdiomaModel.carregarIdioma(language));
    this.setElementLang(language);
  }

  onActivate(event) {
    window.scroll(0, 0);
  }

  setElementLang(language) {
    const lang = document.createAttribute('lang');
    lang.value = language;
    this.el.nativeElement.parentElement.parentElement.attributes.setNamedItem(lang);
  }

  getCookieConsent() {
    return this.cookieService.getCookieConsent();
  }

}
